module.exports = __webpack_public_path__ + "img/e6b67d7.jpg";